import React from 'react'
import PT from 'prop-types'
import Joyride from 'react-joyride'
import Portal from '@vimcar/shared-components/components/Portal'
import linkStore from '@vimcar/shared-utils/linkStore'

import i18n from '#utils/i18n'
import mkStore from './store'

const tp = i18n.prefix('components.WalkthroughWrapper')

const WalkthroughWrapper = ({ onCallback, store, ...props }) =>
  store.showWalkthrough
    ? (
      <Portal isOpen={props.run}>
        <Joyride
          autoStart
          callback={onCallback}
          locale={{ next: tp('next'), close: tp('close'), last: tp('last') }}
          steps={store.walkThroughSteps}
          {...props}
          />
      </Portal>
    )
    : null

WalkthroughWrapper.propTypes = {
  onCallback: PT.func,
  run: PT.bool,
  store: PT.object,
}

export default linkStore(mkStore, WalkthroughWrapper)
